/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Controls_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Style Controls" |
*
* @param {Styles_Controls_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_controls_aria_label = /** @type {((inputs?: Styles_Controls_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Controls_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Controles de style")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stilsteuerung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Controlli di stile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Элементы управления стилем")
	if (locale === "es") return /** @type {LocalizedString} */ ("Controles de estilo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("样式控制")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイルコントロール")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शैली नियंत्रण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Controles de estilo")
	return /** @type {LocalizedString} */ ("Style Controls")
});